module.exports = __webpack_public_path__ + "static/media/undraw_mobile_devices_k1ok.a9b29d86.svg";